import React, {
  useEffect,
  useState,
} from "react";

import {
  Link,
} from "react-router-dom";

/* =========================================================
   STORAGE KEY
========================================================= */

const CONFIRMATION_STORAGE_KEY =
  "kindBonusRushConfirmed";

/* =========================================================
   JOIN CONFIRMATION MODAL
========================================================= */

export default function JoinConfirmationModal() {
  const [
    showModal,
    setShowModal,
  ] = useState(false);

  const [
    accepted,
    setAccepted,
  ] = useState(false);

  /* =======================================================
     REQUIREMENTS
  ======================================================= */

  const points = [
    "This wallet has never interacted with $KIND.",

    "I understand I must not sell, send or receive unauthorized $KIND before completing my claims.",

    "I understand my bonus is divided into 4 claims, with a maximum of one successful claim every 24 hours.",

    "I understand unclaimed rewards expire when the claim period ends or the campaign is officially closed.",
  ];

  /* =======================================================
     CHECK CONFIRMATION
  ======================================================= */

  useEffect(() => {
    try {
      const confirmed =
        localStorage.getItem(
          CONFIRMATION_STORAGE_KEY
        );

      if (confirmed !== "true") {
        setShowModal(true);
      }
    } catch {
      setShowModal(true);
    }
  }, []);

  /* =======================================================
     LOCK BACKGROUND SCROLL
  ======================================================= */

  useEffect(() => {
    if (!showModal) {
      return;
    }

    const originalOverflow =
      document.body.style.overflow;

    document.body.style.overflow =
      "hidden";

    return () => {
      document.body.style.overflow =
        originalOverflow;
    };
  }, [showModal]);

  /* =======================================================
     CONFIRM
  ======================================================= */

  const handleConfirm = () => {
    if (!accepted) {
      return;
    }

    try {
      localStorage.setItem(
        CONFIRMATION_STORAGE_KEY,
        "true"
      );
    } catch {
      // Continue if localStorage is unavailable.
    }

    setShowModal(false);
  };

  /* =======================================================
     DON'T RENDER AFTER CONFIRMATION
  ======================================================= */

  if (!showModal) {
    return null;
  }

  /* =======================================================
     UI
  ======================================================= */

  return (
    <div
      className="
        fixed inset-0
        z-[999999]
        overflow-y-auto
        bg-black/90
        backdrop-blur-md
      "
    >

      {/* ===================================================
          MOBILE SAFE WRAPPER
      =================================================== */}

      <div
        className="
          flex min-h-full
          items-start
          justify-center
          px-3 py-4
          sm:items-center
          sm:px-5
          sm:py-8
        "
      >

        {/* =================================================
            MODAL BOX
        ================================================= */}

        <div
          className="
            relative
            my-auto
            w-full
            max-w-[610px]
            overflow-hidden
            rounded-[16px]
            border
            border-[#ffcc66]/25
            bg-[#08090c]
            shadow-[0_30px_100px_rgba(0,0,0,0.8)]
            sm:rounded-[20px]
          "
        >

          {/* GLOW */}

          <div
            className="
              pointer-events-none
              absolute
              left-1/2
              top-[-130px]
              h-[250px]
              w-[350px]
              -translate-x-1/2
              rounded-full
              bg-[#ffcc66]/10
              blur-[90px]
              sm:top-[-170px]
              sm:h-[300px]
              sm:w-[500px]
            "
          />

          {/* CONTENT */}

          <div className="relative p-4 sm:p-7 md:p-8">

            {/* ===============================================
                HEADER
            =============================================== */}

            <div className="text-center">

              <div
                className="
                  inline-flex
                  items-center
                  gap-2
                  rounded-full
                  border
                  border-[#ffcc66]/20
                  bg-[#ffcc66]/[0.06]
                  px-3
                  py-1.5
                  sm:py-2
                "
              >

                <span
                  className="
                    h-[6px]
                    w-[6px]
                    rounded-full
                    bg-[#ffcc66]
                    shadow-[0_0_10px_rgba(255,204,102,0.8)]
                  "
                />

                <span
                  className="
                    text-[7px]
                    font-black
                    uppercase
                    tracking-[0.18em]
                    text-[#ffcc66]
                    sm:text-[8px]
                  "
                >
                  Before You Join
                </span>

              </div>

              <h2
                className="
                  mt-3
                  whitespace-nowrap
                  text-xl
                  font-black
                  uppercase
                  tracking-[-0.03em]
                  text-white
                  sm:mt-5
                  sm:text-3xl
                "
              >
                KIND BONUS{" "}

                <span className="text-[#ffcc66]">
                  RUSH
                </span>

              </h2>

              <p
                className="
                  mx-auto
                  mt-2
                  max-w-[470px]
                  text-[10px]
                  leading-[18px]
                  text-[#888]
                  sm:mt-3
                  sm:text-[13px]
                  sm:leading-6
                "
              >
                Please review these participation
                requirements before continuing.
              </p>

            </div>

            {/* ===============================================
                REQUIREMENTS
            =============================================== */}

            <div
              className="
                mt-4
                overflow-hidden
                rounded-[10px]
                border
                border-white/[0.08]
                bg-white/[0.015]
                sm:mt-7
                sm:rounded-[14px]
              "
            >

              {points.map(
                (
                  item,
                  index
                ) => (
                  <div
                    key={item}
                    className={`
                      flex
                      items-start
                      justify-between
                      gap-3
                      px-3
                      py-2.5
                      sm:gap-4
                      sm:px-5
                      sm:py-4
                      ${
                        index !==
                        points.length - 1
                          ? "border-b border-white/[0.06]"
                          : ""
                      }
                    `}
                  >

                    {/* TEXT */}

                    <span
                      className="
                        flex-1
                        text-[10px]
                        leading-[17px]
                        text-[#b5b5b5]
                        sm:text-[13px]
                        sm:leading-6
                      "
                    >
                      {item}
                    </span>

                    {/* RIGHT TICK */}

                    <span
                      className="
                        mt-[1px]
                        flex
                        h-[18px]
                        w-[18px]
                        shrink-0
                        items-center
                        justify-center
                        rounded-full
                        border
                        border-[#ffcc66]/35
                        bg-[#ffcc66]/10
                        text-[#ffcc66]
                        sm:mt-[2px]
                        sm:h-[20px]
                        sm:w-[20px]
                      "
                    >

                      <svg
                        viewBox="0 0 24 24"
                        className="h-[10px] w-[10px] sm:h-[12px] sm:w-[12px]"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M5 12l4 4L19 7" />
                      </svg>

                    </span>

                  </div>
                )
              )}

            </div>

            {/* ===============================================
                SINGLE CHECKBOX
            =============================================== */}

            <button
              type="button"
              onClick={() =>
                setAccepted(
                  (current) =>
                    !current
                )
              }
              className={`
                mt-4
                flex
                w-full
                items-start
                gap-3
                rounded-[10px]
                border
                p-3
                text-left
                transition-all
                duration-300
                sm:mt-6
                sm:rounded-[12px]
                sm:p-4
                ${
                  accepted
                    ? "border-[#ffcc66]/35 bg-[#ffcc66]/[0.055]"
                    : "border-white/[0.08] bg-white/[0.015] hover:border-[#ffcc66]/20"
                }
              `}
            >

              {/* CHECKBOX */}

              <span
                className={`
                  mt-[1px]
                  flex
                  h-[19px]
                  w-[19px]
                  shrink-0
                  items-center
                  justify-center
                  rounded-[4px]
                  border
                  transition-all
                  duration-300
                  sm:h-[20px]
                  sm:w-[20px]
                  ${
                    accepted
                      ? "border-[#ffcc66] bg-[#ffcc66]"
                      : "border-white/25 bg-transparent"
                  }
                `}
              >

                <svg
                  viewBox="0 0 24 24"
                  className={`
                    h-[12px]
                    w-[12px]
                    transition-all
                    duration-200
                    ${
                      accepted
                        ? "scale-100 opacity-100"
                        : "scale-50 opacity-0"
                    }
                  `}
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path
                    d="M5 12l4 4L19 7"
                    className="text-black"
                  />
                </svg>

              </span>

              <span
                className={`
                  flex-1
                  text-[10px]
                  font-semibold
                  leading-[17px]
                  transition-colors
                  sm:text-[13px]
                  sm:leading-6
                  ${
                    accepted
                      ? "text-white"
                      : "text-[#999]"
                  }
                `}
              >
                I have read and understand all of
                the requirements above.
              </span>

            </button>

            {/* ===============================================
                JOIN BUTTON
            =============================================== */}

            <button
              type="button"
              disabled={!accepted}
              onClick={handleConfirm}
              className={`
                mt-4
                flex
                min-h-[46px]
                w-full
                items-center
                justify-center
                rounded-[9px]
                px-4
                text-[9px]
                font-black
                uppercase
                tracking-[0.13em]
                transition-all
                duration-300
                sm:mt-6
                sm:min-h-[54px]
                sm:rounded-[10px]
                sm:px-5
                sm:text-[10px]
                sm:tracking-[0.16em]
                ${
                  accepted
                    ? "cursor-pointer bg-[#ffcc66] text-black shadow-[0_10px_35px_rgba(255,204,102,0.10)] hover:-translate-y-[1px] hover:brightness-110"
                    : "cursor-not-allowed border border-white/[0.06] bg-white/[0.035] text-[#4f4f4f]"
                }
              `}
            >
              Join Kind Bonus Rush
            </button>

            {/* ===============================================
                FOOTER
            =============================================== */}

            <p
              className="
                mx-auto
                mt-3
                max-w-[450px]
                text-center
                text-[8px]
                leading-[15px]
                text-[#555]
                sm:mt-4
                sm:text-[9px]
                sm:leading-5
              "
            >
              Participation is subject to the full
              KIND Bonus Rush rules and eligibility
              requirements.
            </p>

            <div className="mt-2 text-center sm:mt-3">

              <Link
                to="/rules"
                className="
                  text-[8px]
                  font-black
                  uppercase
                  tracking-[0.12em]
                  text-[#ffcc66]
                  transition-opacity
                  hover:opacity-75
                  sm:text-[9px]
                  sm:tracking-[0.14em]
                "
              >
                Read Full Rules →
              </Link>

            </div>

          </div>

        </div>

      </div>

    </div>
  );
}